import React from "react";
import { Link } from "react-router-dom";
import NAVBARLIST from "../../db/navBarMenuList";

const FooterFinal = () => {
  return (
    <div className="footer-containerFinal container-fluid">
      <div className="row clearfix p-2 align-items-start justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 d-flex align-items-start justify-content-start flex-column mb-5 pb-5">
          <h3>Contact Us</h3>
          <br />
          <a href={NAVBARLIST.Home}>
            <p>
              <img
                  src="../img/logo-kpals.png"
                  alt="K-PALS UK"
                  style={{maxHeight: "100px", maxWidth: "100px"}}
                />
            </p>

            <p>Kathmandu Institute of Child Health Pals UK</p>
          </a>          
          <br />
          <p>3 Caer Wyan, Llanbadarn Fawr</p>
          <br />
          <p>Aberystwyth</p>
          <br />
          <p>SY23 3GY</p>
          <br />
          <p>Email: kpalsuk@yahoo.com</p>
          <br />
          <p>Charity Registration No. 1209691</p>
          <br />
          <a href="https://www.facebook.com/profile.php?id=61564965185525" target="_blank" rel="noreferrer">
            <p>Follow us on Facebook:</p>
            <p>
              <img
                  src="../img/partners/facebook-1.png"
                  alt="facebook"
                  style={{maxHeight: "40px", maxWidth: "40px"}}
                />
            </p>            
          </a> 
        </div>

        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 d-flex align-items-start justify-content-start flex-column mb-5">
          <h3>Our Partners </h3>
          <br />
          <div className="row align-items-center justify-content-start w-100 pb-2">
            <div className="col-sm-5 col-md-8 col-lg-7 col-xl-7">
                <a href="http://www.ndauk.org.uk/" target="_blank" rel="noreferrer">
                    <p>Nepalese Doctors Association UK</p>
                </a>
            </div>
            <div className="col-sm-2 col-md-4 col-lg-2 col-xl-2">
                <a href="http://www.ndauk.org.uk/" target="_blank" rel="noreferrer">
                    <p><img
                        src="../img/partners/NDAlogo.png" alt="NDAlogo"
                        className="footerLogo"                        
                    /></p>
                </a>
            </div>
          </div>
          <div className="row align-items-center justify-content-start w-100 pb-2">
            <div className="col-sm-5 col-md-8 col-lg-7 col-xl-7">
                <a href="http://www.hexn.org/" target="_blank" rel="noreferrer">
                    <p>Health Exchange Nepal UK</p>
                </a>
            </div>
            <div className="col-sm-2 col-md-4 col-lg-2 col-xl-2">
                <a href="http://www.hexn.org/" target="_blank " rel="noreferrer">
                  <p>
                    <img
                          src="../img/partners/NepaleseNursingAssociationUK-Logo.png" alt="NepaleseNursingAssociationUK-Logo"
                          className="footerLogo"
                    />
                  </p>
                </a>
            </div>
          </div>
          <br />
          <div className="row align-items-center justify-content-start w-100 pb-2">
            <div className="col-sm-5 col-md-8 col-lg-7 col-xl-7">
                <a href="http://www.nnauk.org" target="_blank" rel="noreferrer">
                    <p>Nepalese Nursing Association UK</p>
                </a>
            </div>
            <div className="col-sm-2 col-md-4 col-lg-2 col-xl-2">
                <a href="http://www.nnauk.org" target="_blank" rel="noreferrer">
                  <p>
                    <img
                          src="../img/partners/nnauk.JPG" alt="nnauk_logo"
                          className="footerLogo"
                    />
                  </p>
                </a>
            </div>
          </div>
          <br />
          <br />
        </div>

        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 d-flex align-items-start justify-content-start flex-column">
            <h3>Contact Nepal Team</h3>
            <br/>
            <a href="https://www.kioch.org.np/" target="_blank" rel="noreferrer">
              <p>
                <img
                  src="../img/partners/kiochLogo.jpg"
                  alt="Kioch Nepal"
                  style={{maxHeight: "100px", maxWidth: "100px"}}
                />
              </p>
              <p>Kathmandu Institute of Child Health</p>
            </a>  
            <br/>
            <p>Budhanilkantha Municipality, Ward No-7, Hepali Heights</p>
            <br />
            <p>GPO Box No. 6344</p>
            <br />
            <p>Phone 977-14370373</p>
            <br />
            <p>info@kioch.org.np</p>
        </div>

      </div>
    </div>
  );
};

export default FooterFinal;
